import {
  type AvailableCourseTrack,
  type UrlEntry,
  type UrlRegion,
} from '@/types';

export const isIndexable = false;

export type SyllabusTrack = AvailableCourseTrack;

export type SyllabusPages = `syllabus/${SyllabusTrack}`;

export const urls: Record<
  SyllabusPages,
  Partial<
    | Record<'es', UrlEntry<`${string}/plan-de-estudios`>>
    | Record<'nl', UrlEntry<`${string}/curriculum`>>
    | Record<'pt', UrlEntry<`${string}/plano-de-estudos`>>
    | Record<
        Exclude<UrlRegion, 'es' | 'nl' | 'pt'>,
        UrlEntry<`${string}/syllabus`>
      >
  >
> = {
  'syllabus/ac': {
    de: 'ki-consulting-integration/syllabus',
    'de-en': 'ai-consulting-integration/syllabus',
    es: 'consultor-ia/plan-de-estudios',
    'es-en': 'ai-consulting-integration/syllabus',
    fr: 'consulting-ia/syllabus',
    'fr-en': 'ai-consulting-integration/syllabus',
    gb: 'ai-consulting-integration/syllabus',
    nl: 'ai-consulting-integratie/curriculum',
    'nl-en': 'ai-consulting-integration/syllabus',
    pt: 'consultoria-integracao-ia/plano-de-estudos',
    'pt-en': 'ai-consulting-integration/syllabus',
    ww: 'ai-consulting-integration/syllabus',
  },
  'syllabus/ai': {
    de: 'kunstliche-intelligenz/syllabus',
    'de-en': 'artificial-intelligence/syllabus',
    es: 'inteligencia-artificial/plan-de-estudios',
    'es-en': 'artificial-intelligence/syllabus',
    fr: 'intelligence-artificielle/syllabus',
    'fr-en': 'artificial-intelligence/syllabus',
    gb: 'artificial-intelligence/syllabus',
    nl: 'kunstmatige-intelligentie/curriculum',
    'nl-en': 'artificial-intelligence/syllabus',
    pt: 'inteligencia-artificial/plano-de-estudos',
    'pt-en': 'artificial-intelligence/syllabus',
    ww: 'artificial-intelligence/syllabus',
  },
  'syllabus/ce': {
    de: 'cloud-engineer/syllabus',
    'de-en': 'cloud-engineer/syllabus',
    es: 'cloud-engineer/plan-de-estudios',
    'es-en': 'cloud-engineer/syllabus',
    fr: 'ingenieur-cloud/syllabus',
    'fr-en': 'cloud-engineer/syllabus',
    gb: 'cloud-engineer/syllabus',
    nl: 'cloud-engineer/curriculum',
    'nl-en': 'cloud-engineer/syllabus',
    pt: 'engenharia-cloud/plano-de-estudos',
    'pt-en': 'cloud-engineer/syllabus',
    ww: 'cloud-engineer/syllabus',
  },
  'syllabus/cy': {
    de: 'cybersecurity/syllabus',
    'de-en': 'cybersecurity/syllabus',
    es: 'ciberseguridad/plan-de-estudios',
    'es-en': 'cybersecurity/syllabus',
    fr: 'cybersecurite/syllabus',
    'fr-en': 'cybersecurity/syllabus',
    gb: 'cybersecurity/syllabus',
    nl: 'cybersecurity/curriculum',
    'nl-en': 'cybersecurity/syllabus',
    pt: 'ciberseguranca/plano-de-estudos',
    'pt-en': 'cybersecurity/syllabus',
    ww: 'cybersecurity/syllabus',
  },
  'syllabus/da': {
    de: 'data-analytics/syllabus',
    'de-en': 'data-analytics/syllabus',
    es: 'data-analytics/plan-de-estudios',
    'es-en': 'data-analytics/syllabus',
    fr: 'data-analytics/syllabus',
    'fr-en': 'data-analytics/syllabus',
    gb: 'data-analytics/syllabus',
    nl: 'data-analytics/curriculum',
    'nl-en': 'data-analytics/syllabus',
    pt: 'data-analytics/plano-de-estudos',
    'pt-en': 'data-analytics/syllabus',
    us: 'data-analytics/syllabus',
    ww: 'data-analytics/syllabus',
  },
  'syllabus/de': {
    de: 'data-engineering/syllabus',
    'de-en': 'data-engineering/syllabus',
    es: 'data-engineering/plan-de-estudios',
    'es-en': 'data-engineering/syllabus',
    fr: 'data-engineer/syllabus',
    'fr-en': 'data-engineering/syllabus',
    gb: 'data-engineering/syllabus',
    nl: 'data-engineering/curriculum',
    'nl-en': 'data-engineering/syllabus',
    pt: 'engenharia-dados/plano-de-estudos',
    'pt-en': 'data-engineering/syllabus',
    ww: 'data-engineering/syllabus',
  },
  'syllabus/dv': {
    de: 'devops-cloud-computing/syllabus',
    'de-en': 'devops-cloud-computing/syllabus',
    es: 'devops-cloud-computing/plan-de-estudios',
    'es-en': 'devops-cloud-computing/syllabus',
    fr: 'devops-cloud-computing/syllabus',
    'fr-en': 'devops-cloud-computing/syllabus',
    gb: 'devops-cloud-computing/syllabus',
    nl: 'devops-cloud-computing/curriculum',
    'nl-en': 'devops-cloud-computing/syllabus',
    pt: 'devops-cloud-computing/plano-de-estudos',
    'pt-en': 'devops-cloud-computing/syllabus',
    ww: 'devops-cloud-computing/syllabus',
  },
  'syllabus/mk': {
    de: 'digital-marketing/syllabus',
    'de-en': 'digital-marketing/syllabus',
    es: 'marketing-digital/plan-de-estudios',
    'es-en': 'digital-marketing/syllabus',
    fr: 'marketing-digital/syllabus',
    'fr-en': 'digital-marketing/syllabus',
    gb: 'digital-marketing/syllabus',
    nl: 'digital-marketing/curriculum',
    'nl-en': 'digital-marketing/syllabus',
    pt: 'marketing-digital/plano-de-estudos',
    'pt-en': 'digital-marketing/syllabus',
    ww: 'digital-marketing/syllabus',
  },
  'syllabus/ml': {
    de: 'data-science-machine-learning/syllabus',
    'de-en': 'data-science-machine-learning/syllabus',
    es: 'data-science-machine-learning/plan-de-estudios',
    'es-en': 'data-science-machine-learning/syllabus',
    fr: 'data-science-machine-learning/syllabus',
    'fr-en': 'data-science-machine-learning/syllabus',
    gb: 'data-science-machine-learning/syllabus',
    nl: 'data-science-machine-learning/curriculum',
    'nl-en': 'data-science-machine-learning/syllabus',
    pt: 'data-science-machine-learning/plano-de-estudos',
    'pt-en': 'data-science-machine-learning/syllabus',
    ww: 'data-science-machine-learning/syllabus',
  },
  'syllabus/pm': {
    de: 'ki-product-manager/syllabus',
    'de-en': 'ai-product-manager/syllabus',
    es: 'product-manager-ia/plan-de-estudios',
    'es-en': 'ai-product-manager/syllabus',
    fr: 'product-manager-ia/syllabus',
    'fr-en': 'ai-product-manager/syllabus',
    gb: 'ai-product-manager/syllabus',
    nl: 'product-manager-ai/curriculum',
    'nl-en': 'ai-product-manager/syllabus',
    pt: 'product-manager-ia/plano-de-estudos',
    'pt-en': 'ai-product-manager/syllabus',
    ww: 'ai-product-manager/syllabus',
  },
  'syllabus/ux': {
    de: 'ux-ui-design/syllabus',
    'de-en': 'ux-ui-design/syllabus',
    es: 'diseno-ux-ui/plan-de-estudios',
    'es-en': 'ux-ui-design/syllabus',
    fr: 'ux-ui-design/syllabus',
    'fr-en': 'ux-ui-design/syllabus',
    gb: 'ux-ui-design/syllabus',
    nl: 'ux-ui-design/curriculum',
    'nl-en': 'ux-ui-design/syllabus',
    pt: 'ux-ui-design/plano-de-estudos',
    'pt-en': 'ux-ui-design/syllabus',
    us: 'ux-ui-design/syllabus',
    ww: 'ux-ui-design/syllabus',
  },
  'syllabus/wd': {
    de: 'webentwicklung/syllabus',
    'de-en': 'web-development/syllabus',
    es: 'desarrollo-web/plan-de-estudios',
    'es-en': 'web-development/syllabus',
    fr: 'developpement-web/syllabus',
    'fr-en': 'web-development/syllabus',
    gb: 'web-development/syllabus',
    nl: 'web-development/curriculum',
    'nl-en': 'web-development/syllabus',
    pt: 'programacao-web/plano-de-estudos',
    'pt-en': 'web-development/syllabus',
    us: 'web-development/syllabus',
    ww: 'web-development/syllabus',
  },
};
